import React, { Component } from "react";
import { withRouter, } from "react-router-dom";
import { Col, Container, Row } from 'reactstrap';
import Modal from 'react-modal'
import Select from 'react-select'
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
const formatter = buildFormatter(spanishStrings)

const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '90%',height: '90%',} };

class ModalsVentasPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    	arrProd: {
    		codigo: '',
    		codigoSAT: '',
    		nombre: '',
    		type: '',
    		categoria: '',
    		costo: '',
        precio_compra: 0,
        precio_venta: 0,
    		iva: 0,
    	}
    }
  }
	componentDidMount() {

  }

  render() {
  	const {
  		isOpenAltaProductos,

      //Modal buscar producto
      isOpenSearchProducto,
      arrayListResults,
      indexItemByKeyboard,
      valSearch,
  	} = this.props.subState
  	const { arrProd } = this.state

  	return (
  		<>
				{
					/**
					* ALTA DE PRODUCTOS
					*/
				}

  			<Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={isOpenAltaProductos}
          onRequestClose={() => { this.subSetState({isOpenAltaProductos: false}) }}
          style={this.getStyleModal('isOpenAltaProductos')}
          contentLabel="Registrar nuevo producto"
          >
          <div className="modalBody__operador">
              <h4 style={{ marginBottom: 20, textAlign: 'center', }}>Registrar un producto</h4>

              <div className={'modalsVentas__formAddProducto'}>
              	<p>Código</p>
              	<input type={'text'}
              		placeholder={'Ingresa un código'}
              		onChange={(event) => {
              			arrProd.codigo = event.target.value
              			this.setState({ arrProd, })
              		}}
              		value={arrProd.codigo}
              	/>
              </div>

              <div className={'modalsVentas__formAddProducto'}>
              	<p>Código SAT</p>
              	<input type={'text'}
              		placeholder={'Ingresa un código de SAT'}
              		onChange={(event) => {
              			arrProd.codigoSAT = event.target.value
              			this.setState({ arrProd, })
              		}}
              		value={arrProd.codigoSAT}
              	/>
              </div>

              <div className={'modalsVentas__formAddProducto'}>
              	<p>Nombre del producto</p>
              	<input type={'text'}
              		placeholder={'Ingresa la descripción del producto'}
              		onChange={(event) => {
              			arrProd.nombre = event.target.value
              			this.setState({ arrProd, })
              		}}
              		value={arrProd.nombre}
              	/>
              </div>

              <div className={'modalsVentas__formAddProducto'}>
              	<p>Categoría del producto</p>
              	<Select
		              onChange={(item) => {
		              	arrProd.type = item.type
		              	arrProd.categoria = item.value
              			this.setState({ arrProd, })
		              }}
		              placeholder={'Haz click para buscar un producto'}
		              options={this.props.subState.arrayListCategorias}
		              styles={customStylesOption}
		            />
              </div>

              <div className={'modalsVentas__formAddProducto'}>
              	<p>¿Este producto tiene IVA?</p>
              	<p
              		style={{ cursor: 'pointer' }}
              		onClick={ () => {
              			arrProd.iva = !arrProd.iva
              			this.setState({ arrProd, })
              		}}
              	>{ arrProd.iva == 1 ? 'Si' : 'No' }</p>
              </div>

              <div className={'modalsVentas__formAddProducto'}>
                <p>Precio de compra</p>
                <input type={'text'}
                  placeholder={''}
                  onChange={(event) => {
                    arrProd.precio_compra = event.target.value
                    this.setState({ arrProd, })
                  }}
                  value={arrProd.precio_compra}
                />
              </div>

              <div className={'modalsVentas__formAddProducto'}>
                <p>Precio de venta</p>
                <input type={'text'}
                  placeholder={''}
                  onChange={(event) => {
                    arrProd.precio_venta = event.target.value
                    this.setState({ arrProd, })
                  }}
                  value={arrProd.precio_venta}
                />
              </div>

              <div>
	              <p
	              	className={'modalsVentas__btnAddProducto'}
	              	onClick={() => { this.onAddProducto() }}
	              >Registrar producto</p>
              </div>

          </div>
        </Modal>

        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={isOpenSearchProducto}
          onRequestClose={() => { this.subSetState({isOpenSearchProducto: false}) }}
          style={customStyles}
          contentLabel="Seleccionar un producto"
          >
          <div className="modalBody__operador">
            <Row className="modalBody__corte"> 
              <Col>
                <h4 style={{ margin: 0, }}>Seleccionar un producto</h4>
                <input
                  type="text"
                  placeholder="Ingresa el nombre del producto..."
                  value={valSearch}
                  onChange={(e) => this.onViewProduct(e.target.value) }
                  style={{ margin: '20px auto', }}
                />

                <Row>
                  <Col xs={'8'}>
                    <b>Nombre</b>
                  </Col>
                  <Col xs={'4'}>
                    <b>Categoría</b>
                  </Col>
                </Row>
                {
                  arrayListResults.map((t,e) => (
                    <div key={`ws_list_compra_${e}`}>
                      <Row
                        onClick={ () => { this.props.selectItemProduct(e) } }
                        style={{ width: '100%', margin: '0 auto', marginTop: 5, }}
                        className={`regVentaPage__content ${e === indexItemByKeyboard ? 'regVentaPage__content__active' : null}`}
                      >
                        <div className="regVentaPage__separator"></div>
                        <Col xs={'8'} className="regVentaPage__listProduct">
                          <p style={{ color: '#333', margin: 0, }}>{t.nombre}</p>
                        </Col>
                        <Col xs={'4'} className="regVentaPage__listPrices">
                          <p style={{ color: '#333', margin: 0, }}>{t.categoria}</p>
                        </Col>
                      </Row>
                    </div>
                  ))
                }

              </Col>
            </Row>
          </div>
        </Modal>


  		</>
  	)
  }

  /*************
  **
  ** MODAL ALTA
  **
  ************/


  onAddProducto() {
    const { arrProd } = this.state
    const { codigo, nombre, type, categoria, precio_venta, } = arrProd
    //Validar
    if( codigo.trim() == '' || nombre.trim() == '' || type == '' ) {
      alert('Por favor, rellena los campos del formulario.');
      return false
    }


    //Registrar en BD
    const data = {
      ...arrProd,
      id_sucursal: this.props.initState.id_sucursal,
      id_vendedor: this.props.initState.id_vendedor,
    }

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setRegisterProducto", this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {

      //Finalizado agregamos en el array de productos
      const { arrayListProductos, arrayMinListProductos, } = this.props.subState

      arrayListProductos.push({
        categoria,
        fecha_cambio_costo: response.fecha,
        folio: codigo,
        id_producto: response.id_producto,
        nombre: (codigo + " - " + nombre),
        precio_venta,
        update: 0,
      })

      arrayMinListProductos.push({
        id_producto: response.id_producto,
        label: (codigo + " - " + nombre),
        value: (codigo + " - " + nombre),
      })

      this.props.subSetState({ arrayListProductos, arrayMinListProductos, isOpenAltaProductos: false, })

      this.setState({
        arrProd: {
          codigo: '',
          codigoSAT: '',
          nombre: '',
          type: '',
          categoria: '',
          costo: '',
          precio_compra: 0,
          precio_venta: 0,
          iva: 0,
        }
      })

      alert("Producto registrado con éxito.")
    })
  }

  /*************
  **
  ** MODAL BUSCAR PRODUCTO
  **
  ************/

  onViewProduct(val) {
    let { arrayListProductos } = this.props.subState

    this.props.subSetState({ valSearch: val })
    let countLimit = 0

    arrayListProductos = arrayListProductos.filter(function(producto, index) {
      if(countLimit <= 10) {
        if(typeof producto.nombre === 'undefined' || !producto.nombre) {
        } else {
          if(producto.nombre.toLowerCase().indexOf(val.toLowerCase()) !== -1) {
            countLimit++
            return true
          }
        }
      }
    });
    this.props.subSetState({ arrayListResults: arrayListProductos });
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  subSetState(param) {
  	this.props.subSetState(param)
  	return true
  }

  headersPOST(data) {
  	return {
  		method: "POST",
  		mode: "cors",
  		body: JSON.stringify(data),
  	}
  }

  getStyleModal(opt) {
    if(opt === 'isOpenAltaProductos') {
      return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '50%',height: '50%',} };
    }

    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }


};

export default withRouter(ModalsVentasPage)